import { Typography } from "@shared/ui.primitives";
import type { TitleDescription } from "@shared/graphql.types";
import * as styles from "./PerfectForText.css";

type PerfectForTextProps = {
  items: TitleDescription[];
};

export const PerfectForText: React.FC<PerfectForTextProps> = ({ items }) => {
  return (
    <div>
      {items.map((item, index) => {
        return (
          <div key={index} className={styles.wrapper}>
            <Typography as="h6" variant="subheader-7" colour="accent-dark">
              {item.title}
            </Typography>
            <Typography variant="body-md">{item.description}</Typography>
          </div>
        );
      })}
    </div>
  );
};
